import { render, staticRenderFns } from "./UserTag.vue?vue&type=template&id=dd2de542"
import script from "../../../scripts/partials/user/UserTag.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/user/UserTag.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports